const KEEP_DRAWER_OPEN_SELECTORS = [
  "[data-overview-chart]",
  "[data-competitor-chart]",
  "[data-overview-filter-bar]",
  "[data-top-nav]",
  "[role='menu']",
  "[data-radix-popper-content-wrapper]",
];

export function shouldKeepTopicDetailDrawerOpen(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return KEEP_DRAWER_OPEN_SELECTORS.some((selector) => target.closest(selector) !== null);
}
